(() => {
  // Both product sections use this asset; Shopify can reload either independently.
  if (window.mbbProductMotion) return;
  window.mbbProductMotion = true;
  const instances = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 990px)');

  function mount(section) {
    if (instances.has(section)) return;
    const targets = [...section.querySelectorAll('[data-mbb-reveal]')];
    const animations = new Set();
    let revealObserver;
    const show = () => {
      revealObserver?.disconnect();
      targets.forEach(target => { target.style.removeProperty('opacity'); });
      animations.forEach(animation => animation.cancel());
      animations.clear();
    };
    if (!reduced.matches && 'IntersectionObserver' in window && Element.prototype.animate) {
      revealObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          revealObserver.unobserve(entry.target);
          entry.target.style.removeProperty('opacity');
          const animation = entry.target.animate(
            [{ opacity: 0, transform: 'translateY(20px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 650, delay: targets.indexOf(entry.target) * 90, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' }
          );
          animations.add(animation);
          animation.onfinish = () => animations.delete(animation);
        });
      }, { threshold: 0.08 });
      targets.forEach(target => { target.style.opacity = '0'; revealObserver.observe(target); });
    }

    const media = section.querySelector('[data-mbb-banner-media]');
    const strength = Math.max(0, Math.min(80, Number(section.dataset.parallaxStrength) || 0));
    let frame = 0;
    let listening = false;
    let visible = true;
    let visibilityObserver;
    const update = () => {
      frame = 0;
      if (!listening || !visible) return;
      const rect = section.getBoundingClientRect();
      const height = window.innerHeight;
      if (rect.bottom <= 0 || rect.top >= height) return;
      const progress = Math.max(-1, Math.min(1, (height / 2 - rect.top - rect.height / 2) / ((height + rect.height) / 2)));
      media.style.transform = `translate3d(0, ${progress * strength}px, 0)`;
    };
    const schedule = () => { if (visible && !frame) frame = window.requestAnimationFrame(update); };
    const stop = () => {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      window.cancelAnimationFrame(frame);
      frame = 0;
      listening = false;
      media?.style.removeProperty('transform');
    };
    const configure = () => {
      stop();
      if (reduced.matches) show();
      if (!media || section.dataset.parallax !== 'true' || !desktop.matches || reduced.matches) return;
      listening = true;
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      schedule();
    };
    if (media && 'IntersectionObserver' in window) {
      visibilityObserver = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible && listening) schedule();
      });
      visibilityObserver.observe(section);
    }
    reduced.addEventListener('change', configure);
    desktop.addEventListener('change', configure);
    configure();
    instances.set(section, () => {
      stop(); show(); visibilityObserver?.disconnect();
      reduced.removeEventListener('change', configure);
      desktop.removeEventListener('change', configure);
      instances.delete(section);
    });
  }
  const init = (root = document) => root.querySelectorAll('.mbb-product-contents, .mbb-product-banner').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, section) => { if (event.target.contains(section)) cleanup(); });
  });
})();
